import { Routes } from '@angular/router';
import { RoutePaths } from '../shared/api/types/enums';

// Auth
// authMode drives which body SignInComponent renders (NBO-2387). The empty-path
// child inside AuthRoutingModule inherits this data under the router's default
// `emptyOnly` inheritance strategy — do not derive the mode from router.url
// string comparison (breaks on query strings; see NBO-2387).
export const authRoutes: Routes = [
  {
    path: RoutePaths.SignIn,
    data: { authMode: 'signin' },
    loadChildren: () => import('src/app/auth/auth.module').then((mod) => mod.AuthModule)
  },
  {
    path: RoutePaths.MFA,
    data: { authMode: 'mfa' },
    loadChildren: () => import('src/app/auth/auth.module').then((mod) => mod.AuthModule)
  },
  {
    path: RoutePaths.ResetPassword,
    data: { authMode: 'reset' },
    loadChildren: () => import('src/app/auth/auth.module').then((mod) => mod.AuthModule)
  }
];
